import React from 'react';
import PropTypes from 'prop-types';
import { calendarType, displayRange } from './calendarPresentation';
import SchoolCalendarBreaks from './SchoolCalendarBreaks';
import './schoolCalendar.scss';

export default function SchoolCalendarSummaryCard({ calendar, actions }) {
  return (
    <section className="school-calendar-summary school-calendar-panel" aria-label="Podsumowanie kalendarza szkoły">
      <div>
        <h2>Kalendarz szkoły</h2>
        <p>Rok szkolny {calendar.schoolYearStart}/{calendar.schoolYearStart + 1}</p>
        {calendar.integrationPending && <p>Kalendarz informacyjny — daty nie zmieniają jeszcze planu lekcji ani rozliczeń.</p>}
        {calendar.status === 'updating' && <p>Trwa aktualizacja kalendarza.</p>}
        {calendar.teachingPeriod ? <p>Okres prowadzenia zajęć: <strong>{displayRange(calendar.teachingPeriod)}</strong></p>
          : <p>Kalendarz na ten rok nie został jeszcze skonfigurowany.</p>}
      </div>
      {calendar.teachingPeriod && (
        <div>
          <h3>Przerwy i dni wolne</h3>
          <SchoolCalendarBreaks calendar={calendar} />
        </div>
      )}
      {actions && <div className="school-calendar-summary-actions">{actions}</div>}
    </section>
  );
}
SchoolCalendarSummaryCard.propTypes = { calendar: calendarType.isRequired, actions: PropTypes.node };
SchoolCalendarSummaryCard.defaultProps = { actions: null };
